module.exports = __webpack_public_path__ + "static/media/mx.0470b8ab.webp";